if (!customElements.get('cart-addons')) {
  customElements.define(
    'cart-addons',
    class CartAddOns extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      async onClick(event) {
        const button = event.target.closest('[data-cart-addon-add]');
        if (!button || !this.contains(button) || button.disabled) return;

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        event.preventDefault();
        this.clearStatus();
        this.setLoading(button, true);

        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId);
        let cartWasUpdated = false;

        try {
          const isDrawer = this.dataset.context === 'drawer';
          const cartDrawer = isDrawer ? document.querySelector('cart-drawer') : null;
          const requestBody = {
            items: [{ id: Number(variantId), quantity: 1 }],
          };

          if (cartDrawer) {
            requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
            requestBody.sections_url = window.location.pathname;
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify(requestBody);

          const response = await fetch(routes.cart_add_url, config);
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || window.cartStrings.error);
          }

          cartWasUpdated = true;
          await this.resolveCartLinesUpdate(linesUpdateDeferred);

          if (!cartDrawer) {
            window.location.reload();
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try {
              await publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-addons',
                productVariantId: variantId,
                cartData: parsedState,
              });
            } catch (publishError) {
              console.error(publishError);
            }
          }

          cartDrawer.renderContents(parsedState);
        } catch (error) {
          if (cartWasUpdated) {
            window.location.reload();
            return;
          }

          linesUpdateDeferred?.reject(error);
          this.showStatus(error.message || window.cartStrings.error);
          this.setLoading(button, false);
        }
      }

      createCartLinesUpdateEvent(variantId) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'cart',
            lines: [{ merchandiseId: variantId, quantity: 1 }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      async resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        try {
          const cart =
            typeof CartItems !== 'undefined'
              ? await CartItems.fetchCartData()
              : await fetch(`${routes.cart_url}.json`).then((response) => response.json());

          if (!cart?.currency) throw new Error('Missing currency in cart response');
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
        } catch (error) {
          deferred.reject(error);
        }
      }

      setLoading(activeButton, isLoading) {
        this.querySelectorAll('[data-cart-addon-add]').forEach((button) => {
          button.disabled = isLoading;
          button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        });

        activeButton.querySelector('[data-cart-addon-label]')?.toggleAttribute('hidden', isLoading);
        activeButton.querySelector('[data-cart-addon-loading]')?.toggleAttribute('hidden', !isLoading);
      }

      clearStatus() {
        const status = this.querySelector('[data-cart-addon-status]');
        if (!status) return;
        status.textContent = '';
        status.hidden = true;
      }

      showStatus(message) {
        const status = this.querySelector('[data-cart-addon-status]');
        if (!status) return;
        status.textContent = message;
        status.hidden = false;
      }
    }
  );
}
